import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';



@Injectable()
export class FileUploadService {
  _url!: string;
  apiFileUrl!: string;
  constructor(private http: HttpClient) {
  }


  uploadFile(data: any): Observable<{}> {
    this._url = 'api/AppXtender/UploadFile';
    let headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    }
    return this.http.post(this._url, data, { reportProgress: true, observe: 'events' });
  }

  private handleData(res: Response) {
    let data = res.json();
    return data;
  }
  private handleError(error: Response | any) {
    return Observable.throw('API failed');
  }




}
